import { randomId } from '../../../../Hooks';
import { AdditionalFieldOption } from './AdditionalFields.types';

const convertToInternalOption = (option: AdditionalFieldOption) => {
  return {
    ...option,
    type: option.type || 'textfield',
    key: randomId(),
    options: option.options?.map((option) => ({ key: randomId(), value: option })),
  };
};

export { convertToInternalOption };
